import React, { useEffect, useState } from 'react';
import { Users, ChevronLeft, ChevronRight } from 'lucide-react';
import { Card } from '../ui/Card';
import { mockInterviews } from '../../utils/mockData';
import { getMonthDays, getToday } from '../../utils/dateUtils';
export function InterviewCalendarWidget() {
  const [currentDate, setCurrentDate] = useState(getToday());
  const [calendarDays, setCalendarDays] = useState<(Date | null)[]>([]);
  const [interviewMap, setInterviewMap] = useState<Record<number, number>>({});
  useEffect(() => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    setCalendarDays(getMonthDays(year, month));
    const counts: Record<number, number> = {};
    mockInterviews.forEach(interview => {
      if (interview.type !== 'In-Person') return;
      const interviewDate = new Date(interview.dateTime);
      if (interviewDate.getMonth() === month && interviewDate.getFullYear() === year) {
        const day = interviewDate.getDate();
        counts[day] = (counts[day] || 0) + 1;
      }
    });
    setInterviewMap(counts);
  }, [currentDate]);
  const nextMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  const prevMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  const monthName = currentDate.toLocaleString('default', {
    month: 'long',
    year: 'numeric'
  });
  const today = getToday();
  return <Card title="In-Person Interviews" icon={<Users className="h-4 w-4" data-id="element-1034" />} action={<div className="flex items-center gap-1" data-id="element-1035">
          <button onClick={prevMonth} className="p-1 hover:bg-orange-50 rounded-full transition-colors" data-id="element-1036">
            <ChevronLeft className="h-3.5 w-3.5 text-gray-600" data-id="element-1037" />
          </button>
          <span className="text-[11px] font-medium w-20 text-center text-gray-700" data-id="element-1038">
            {monthName}
          </span>
          <button onClick={nextMonth} className="p-1 hover:bg-orange-50 rounded-full transition-colors" data-id="element-1039">
            <ChevronRight className="h-3.5 w-3.5 text-gray-600" data-id="element-1040" />
          </button>
        </div>} data-id="element-1033">
      <div className="space-y-1.5" data-id="element-1041">
        <div className="grid grid-cols-7 gap-0.5 text-center" data-id="element-1042">
          {['M', 'T', 'W', 'T', 'F', 'S', 'S'].map((d, i) => <div key={`${d}-${i}`} className="text-[9px] font-medium text-gray-400 py-0.5" data-id="element-1043">
              {d}
            </div>)}
        </div>
        <div className="grid grid-cols-7 gap-0.5" data-id="element-1044">
          {calendarDays.map((date, idx) => {
          if (!date) return <div key={`empty-${idx}`} className="h-6" data-id="element-1045" />;
          const dayNum = date.getDate();
          const count = interviewMap[dayNum];
          const isToday = date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
          return <div key={idx} className={`h-6 flex flex-col items-center justify-center rounded text-[10px] relative ${isToday ? 'bg-gradient-to-br from-orange-50 to-orange-100 text-orange-700 font-bold border border-orange-200 shadow-sm' : 'hover:bg-gray-50 text-gray-700'} ${count ? 'cursor-pointer' : ''}`} title={count ? `${count} interview${count > 1 ? 's' : ''}` : undefined} data-id="element-1046">
                <span data-id="element-1047">{dayNum}</span>
                {count > 0 && <div className="absolute bottom-0.5 h-0.5 w-0.5 rounded-full bg-orange-600" data-id="element-1048" />}
              </div>;
        })}
        </div>
      </div>
    </Card>;
}